import axios from 'axios'

export const api = axios.create({
    baseURL: "https://gk09ijsv9g.execute-api.us-east-1.amazonaws.com/stage/"
})

api.interceptors.request.use((config) => {
    return config
});
api.interceptors.response.use(
    (response) => {
        return response
    },
    (error) => {
        // console.log('error', error.response);
        throw error.response.data
    }
);